// @ts-nocheck
import styled from '@emotion/styled';

import { colors, fonts } from '../../styles';

interface HeadingProps {
  color?: string;
  weight?: number;
  ellipsis?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Heading1 = styled('span')<HeadingProps>`
  color: ${(props) => props.color || colors.black};
  font-size: ${fonts.size.large};
  font-weight: ${(props) => props.weight || fonts.weight.medium};
  line-height: 1.28;
  letter-spacing: normal;
  ${(props) => props.ellipsis && 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'};
`;

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Heading2 = styled('span')<HeadingProps>`
  color: ${(props) => props.color || colors.black};
  font-size: ${fonts.size.medium};
  font-weight: ${(props) => props.weight || fonts.weight.medium};
  line-height: 1.31;
  letter-spacing: normal;
  ${(props) => props.ellipsis && 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'};
`;
